module.exports = __webpack_public_path__ + "img/icon2.bde1438.webp";